import { baseUrl } from "../utils/baseUrl";
import jwtInterceptor from "./autorizacao/jwt-interceptor";

class ServicosCargo {
    create(cargo) {
        return jwtInterceptor.post(`${baseUrl}/cargos`, cargo)
    }
    listarTodos(){
        return jwtInterceptor.get(`${baseUrl}/cargos`)
    }

    editar(id, cargo){
        return jwtInterceptor.put(`${baseUrl}/cargos/${id}`, cargo)
    }
    deletar(id){
        return jwtInterceptor.delete(`${baseUrl}/cargos/${id}`)
    }
}

export default new ServicosCargo();